import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="about-section py-5">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="fw-bold text-success mb-3">About Us</h2>
          <p className="text-muted fs-5">
            🌍 Delivering Trust, Connecting Worlds Since 2013
          </p>
        </div>

        <div className="row align-items-center gy-4">
          <div className="col-lg-6" data-aos="fade-right">
            <p className="lead text-muted">
              <strong>D2D Express</strong> is a trusted name in international courier and logistics, 
              connecting Tamil Nadu to the world for over <strong>12 years</strong>. We ensure every 
              shipment — from urgent documents to delicate parcels — reaches its destination safely 
              and on time.
            </p>

            <p className="lead text-muted">
              Our dedicated professionals combine <strong>local expertise</strong> with 
              <strong> global reach</strong>, offering transparent, dependable, and innovative logistics 
              solutions that bring peace of mind to every customer.
            </p>
          </div>

          <div className="col-lg-6" data-aos="fade-left">
            <div className="why-choose-us shadow-sm rounded-4 p-4 bg-white h-100">
              <h4 className="fw-bold text-success mb-3">✅ Why Choose Us?</h4>
              <ul className="list-unstyled">
                <li>🚚 On-Time Guaranteed Deliveries</li>
                <li>📦 Door-to-Drop Real-Time Tracking</li>
                <li>💼 Tailored Solutions for Businesses & Individuals</li>
                <li>🛡️ Expert Handling of Fragile & High-Value Cargo</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row mt-5 gy-4">
          <div className="col-md-6" data-aos="fade-right">
            <h4 className="fw-bold text-success section-title">Our Vision</h4>
            <p className="lead text-muted">
              “To revolutionize logistics by blending local roots with global expertise — ensuring
              seamless, on-time deliveries that exceed customer expectations worldwide.”
            </p>
          </div>

          <div className="col-md-6" data-aos="fade-left">
            <h4 className="fw-bold text-success section-title">Our Mission</h4>
            <p className="lead text-muted">
              “At D2D Express, we prioritize trust, innovation, and customer satisfaction. We craft 
              tailored solutions, embrace technology, and uphold integrity to make global shipping 
              simple, safe, and swift.”
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
